import { createNamespace } from '../utils';
import Overlay from '../overlay';
import Icon from '../icon';
import Button from '../button';

var _createNamespace = createNamespace('image-dialog'),
    createComponent = _createNamespace[0],
    bem = _createNamespace[1];

export default createComponent({
  props: {
    show: Boolean,
    imgUrl: String,
    title: String,
    content: String,
    buttonText: String
  },
  methods: {
    close: function close() {
      this.$emit('close');
    },
    confirm: function confirm() {
      this.$emit('confirm');
    }
  },
  render: function render() {
    var h = arguments[0];
    var closeIcon = h(Icon, {
      "attrs": {
        "role": "button",
        "tabindex": "0",
        "name": "close"
      },
      "class": bem('close-icon'),
      "on": {
        "click": this.close
      }
    });
    var image = this.slots('image') || this.imgUrl && h("img", {
      "class": bem('image'),
      "attrs": {
        "src": this.imgUrl
      }
    });
    var body = (this.content || this.title || this.buttonText) && h("div", {
      "class": bem('body')
    }, [this.title && h("div", {
      "class": bem('title')
    }, [this.title]), this.content && h("div", {
      "class": bem('content')
    }, [this.content]), this.buttonText && h(Button, {
      "attrs": {
        "type": "primary",
        "block": true
      },
      "class": bem('button'),
      "on": {
        "click": this.confirm
      }
    }, [this.buttonText])]);
    return h(Overlay, {
      "attrs": {
        "show": this.show
      },
      "class": bem()
    }, [h("div", {
      "class": bem('wrapper')
    }, [closeIcon, h("div", {
      "class": bem('content-wrapper')
    }, [image, body, this.slots()])])]);
  }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant-green/es/image-dialog/index.js
// module id = null
// module chunks = 